export function pxToNum(val) {
  return parseInt(val.slice(0, -2), 10);
}
